document.addEventListener('DOMContentLoaded', function () {
  // Delegated variant change handler
  document.body.addEventListener('change', function (e) {debugger;
    if (e.target.classList.contains('variant__selected_bundle')) {
      const dropdown = e.target;
      const productId = dropdown.dataset.productId;
      const hiddenInput = document.querySelector(`.selected-variant-input[data-product-id="${productId}"]`);
      if (hiddenInput) {
        hiddenInput.value = dropdown.value;
        console.log("Variant changed:", productId, "->", dropdown.value);
      } else {
        console.warn("Hidden input not found for product", productId);
      }
    }
  });

  // Delegated Add to Cart handler
  document.body.addEventListener('click', function (e) {
    const button = e.target.closest('.btn-add-to-cart');
    if (button) {
      e.preventDefault();
      const productId = button.dataset.blockId;
      const hiddenInput = document.querySelector(`.selected-variant-input[data-product-id="${productId}"]`);
      const variantId = hiddenInput?.value;

      if (!variantId) {
        // alert('Variant not selected!');
        // console.error("No variant ID for product", productId);
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(res => {
          if (!res.ok) throw new Error("Cart add failed");
          return res.json();
        })
        .then(data => {
          console.log('Added to cart:', data);

          // Refresh cart drawer
          return fetch('/cart?view=drawer');
        })
        .then(res => res.text())
        .then(html => {
          const cartItems = document.querySelector('.cart-items');
          if (cartItems) cartItems.innerHTML = html;
          const cartDrawer = document.getElementById('cart-drawer');
          if (cartDrawer) cartDrawer.classList.add('open');
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
        });
    }
  });

  // Optional: close cart drawer
  const closeCart = document.querySelector('.close-cart');
  if (closeCart) {
    closeCart.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('cart-drawer').classList.remove('open');
    });
  }
});

function updateCartCount() {
  fetch("/cart.js")
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      // Update the cart item count on the page
      document.querySelector(".cart-count").innerHTML = cart.item_count;
    });
}

setInterval(updateCartCount, 1000);

$(document).ready(function () {
  $(document).on("click", ".accordion-list .accordion__content input", function () {
    setTimeout(function () {
      var dataCount = parseInt(
        $(".collection-toolbar__products-count").attr("data-count")
      );
      $(".facets-drawer .count-filter-own").text("(" + dataCount + ")");
    }, 2000);
  });
});

$(document).ready(function() {
  var inventoryDiv = $('[data-block-type="inventory"]');
  var appDiv = $('[data-block-type="@app"]');
  
  if (inventoryDiv.length && appDiv.length) {
    appDiv.insertAfter(inventoryDiv);
  }
});


$(document).ready(function(){
  $('.nls-custom-slider').slick({
    infinite: true,
    slidesToShow: 4.2,
    slidesToScroll: 1,
    speed: 300,
    autoplay: false,
    arrows: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4.2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.2
      }
    }
  ]      
  });
});

$(document).ready(function () {
  function initMobileGalleryModal() {
      // Remove any existing click handlers to avoid duplicates
      $(document).off('click', '.product-gallery__media.slick-active .custom-zoom_button');

      let winWidth = $(window).width();

      if (winWidth <= 999) {
          $(document).on('click', '.product-gallery__media.slick-active .custom-zoom_button', function (e) {
              e.preventDefault();
              $('body').addClass('overflow');

              var $modalSlider = $('.mobile_gallery_modal .mobile_media-slider');
              $modalSlider.empty();
              $('.modal-nav').remove();

              // Clone original slides excluding slick clones
              var galleryHTML = $('.product-gallery__media').not('.slick-cloned').map(function () {
                  var $clone = $(this).clone();

                  // Remove slick classes
                  $clone.removeClass(function (index, className) {
                      return (className.match(/(^|\s)slick\S+/g) || []).join(' ');
                  });

                  return $clone.prop('outerHTML');
              }).get().join('');

              // Get current slide index
              
              var currentIndex = $(this).parents('.product-gallery__media.slick-active').index();

              // Add cloned slides to modal
              $modalSlider.html(galleryHTML);

              // Initialize slick slider on modal
              if ($modalSlider.hasClass('slick-initialized')) {
                  $modalSlider.slick('unslick');
              }
              setTimeout(function(){
              $modalSlider.slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                  dots: false,
                  infinite: true
              });
          

              // Go to the current slide
              $modalSlider.slick('slickGoTo', currentIndex - 1);

              $modalSlider.on('beforeChange swipe', function () {
                $('.mobile_gallery_modal.show img').removeClass('active');
              });
              
            },500);
              var navHTML = `
                  <div class="modal-nav">
                      <button type="button" class="modal-prev circle-button hover:animate-icon-inline">
                          <svg aria-hidden="true" fill="none" width="16" viewBox="0 0 16 18">
                              <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path>
                          </svg>
                      </button>
                      <button type="button" class="modal-close circle-button hover:animate-icon-block">
                          <svg aria-hidden="true" fill="none" width="16" viewBox="0 0 18 18">
                              <path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-linecap="square"></path>
                          </svg>
                      </button>
                      <button type="button" class="modal-next circle-button hover:animate-icon-inline">
                          <svg aria-hidden="true" fill="none" width="16" viewBox="0 0 16 18">
                              <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
                          </svg>
                      </button>
                  </div>
              `;
            
            setTimeout(function(){
              $('.mobile_gallery_modal').append(navHTML).addClass('show');
              },1000);

              // Attach modal nav events (these will rebind each time modal opens)
              $(document).off('click', '.modal-prev').on('click', '.modal-prev', function () {
                  $('.mobile_gallery_modal.show img').removeClass('active');
                  $('.mobile_gallery_modal .mobile_media-slider').slick('slickPrev');
              });
              $(document).off('click', '.modal-next').on('click', '.modal-next', function () {
                  $('.mobile_gallery_modal.show img').removeClass('active');
                  $('.mobile_gallery_modal .mobile_media-slider').slick('slickNext');
              });
              $(document).off('click', '.modal-close').on('click', '.modal-close', function () {
                  $('.mobile_gallery_modal.show img').removeClass('active');  
                  $('.mobile_gallery_modal').removeClass('show');
                  $('body').removeClass('overflow');
                  
              });
          });
      
          $(document).on('click','.mobile_gallery_modal.show img',function(){
            $(this).toggleClass('active');
          });
      }
  }

  // Run on page load
  $(document).ready(initMobileGalleryModal);

  // Run again on window resize (debounced to avoid firing too often)
  let resizeTimer;
  $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initMobileGalleryModal, 200);
  });
});


document.addEventListener("DOMContentLoaded", function () {

  // --------------------------
  // Initialize Swiper
  // --------------------------
  function initSwiper() {
    document.querySelectorAll('.custom-swiper-container').forEach(function (swiperContainer) {
      if (!swiperContainer.classList.contains('swiper-initialized')) {
        new Swiper(swiperContainer, {
          loop: true,
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          },
        });
        swiperContainer.classList.add('swiper-initialized');
      }
    });
  }

  // --------------------------
  // Main update handler
  // --------------------------
  function handleUpdates() {
    initSwiper();
  }

  // --------------------------
  // Initial load
  // --------------------------
  handleUpdates();

  // --------------------------
  // On window resize
  // --------------------------
  window.addEventListener("resize", handleUpdates);

  // --------------------------
  // On jQuery AJAX complete
  // --------------------------
  if (window.jQuery) {
    $(document).on("ajaxComplete", function () {
      setTimeout(handleUpdates, 500);
    });
  }

  // --------------------------
  // Override fetch safely
  // --------------------------
  function observeFetch() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      return originalFetch(...args).then((response) => {
        if (response.ok) {
          // Try to parse JSON safely, ignore errors
          response.clone().text().then((text) => {
            try {
              JSON.parse(text);
            } catch (e) {
              // Not JSON, ignore
            } finally {
              setTimeout(handleUpdates, 500);
            }
          });
        }
        return response;
      });
    };
  }
  observeFetch();

  // --------------------------
  // MutationObserver for dynamic DOM changes
  // --------------------------
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(handleUpdates, 500);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

});


document.addEventListener('DOMContentLoaded', function () {
  // Initialize Swiper
  var chcSwiper = new Swiper('.chc-swiper', {
    slidesPerView: 6.6,
    spaceBetween: 32,
    freeMode: true,
    grabCursor: true,
    watchOverflow: true,
    slideToClickedSlide: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      0: {
        spaceBetween: 8,
        slidesPerView: 3.3,
      },
      768: {
        slidesPerView: 6.6,
        spaceBetween: 32,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
    on: {
      // update small bottom active-bar width proportionally to current progress
      slideChange: updateActiveBar,
      progress: updateActiveBar,
      resize: updateActiveBar,
      init: updateActiveBar
    }
  });

  function updateActiveBar() {
    try {
      var container = document.querySelector('.chc-track-indicator');
      var bar = container.querySelector('.active-bar');
      // Progress between 0 and 1
      var prog = chcSwiper.progress || 0;
      // We'll set width as percentage of container width depending on number of slides visible vs total
      var slides = chcSwiper.slides.length;
      var visible = Math.max(1, Math.floor(chcSwiper.params.slidesPerView === 'auto' ? (document.documentElement.clientWidth / parseInt(getComputedStyle(chcSwiper.el.querySelector('.swiper-slide')).width || 220)) : chcSwiper.params.slidesPerView));
      // fallback: compute visible by measuring wrapper
      var wrapper = chcSwiper.el.querySelector('.swiper-wrapper');
      var slide = chcSwiper.el.querySelector('.swiper-slide');
      if (slide && wrapper) {
        var slideW = slide.getBoundingClientRect().width + chcSwiper.params.spaceBetween;
        var wrapperW = chcSwiper.el.getBoundingClientRect().width;
        visible = Math.max(1, Math.floor(wrapperW / slideW));
      }
      var visiblePerc = (visible / slides) * 100;
      // width should be at least visiblePerc, and shift by progress * (100 - visiblePerc)
      var widthPerc = visiblePerc;
      // Also animate width slightly depending on viewport
      var offsetPerc = prog * (100 - visiblePerc);
      bar.style.width = widthPerc + '%';
      bar.style.transform = 'translateX(' + offsetPerc + '%)';
    } catch (e) {
      // ignore
    }
  }

});